import { Modal as AntdModal } from "@empglabs/backoffice-ui-kit"
import { forwardRef } from "react"

const Modal = forwardRef((props, ref) => {
  return <AntdModal ref={ref} {...props} />
})

export default Modal
